// https://vuex.vuejs.org/en/actions.html

import {
  ListAccessibleOrgs,
  ListOrgUsers,
  ListVehicleTypes
} from "@/services/API.js";

import { Logger } from "aws-amplify";
const logger = new Logger("VUEX - ACTIONS");

export default {
  async getOrgs({ commit, state }) {
    if (state.orgs.length > 0) return
    const res = await ListAccessibleOrgs();
    logger.debug(res);
    if (res) {
      commit('setOrgs', res)
    }
  },

  async getUsers({ commit, state }) {
    if (state.users.length > 0) return
    const res = await ListOrgUsers(state[state.email].Org.id);
    if (res)
      commit('setUsers', res.Users.map(user => {
        user.name = user.firstName + " " + user.lastName;
        return user;
      }))
  },

  async getVehiType({ commit, state }) {
    if (state.vehiType.length > 0) return 101;
    const res = await ListVehicleTypes();
    if (res)
      commit('setVehiType', res.Types)
  },
}
